module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei8.svg";